import React, {forwardRef, useCallback, useEffect, useState} from "react";
import {Button, ButtonToolbar, Checkbox, DatePicker, Form, Input, Modal, SelectPicker, Stack} from 'rsuite';
import {deleteUserProject, updateUserProject} from "../../../service/projectService";
import {projectModel} from "../../form/models";
import {
    descriptionPlaceholder,
    projectNamePlaceholder,
    responsibilitiesPlaceholder,
    technologiesPlaceholder
} from "../../constants/projectConstants";


const startDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);
const endDateInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);

const descriptionTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const technologiesTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const responsibilitiesTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const EditProjectModal = (props) => {
    const { open, handleClose, userExperience, project, userId } = props;

    const [localState, setLocalState] = useState({userId});

    const localClose = useCallback((response) => {
        handleClose(response);
        setLocalState({});
    }, [handleClose]);

    const submitProjectEdit = useCallback((isFormValid) => {
        if(!isFormValid) return;
        updateUserProject(localState).then((response) => {
            localClose(response);
        });
    }, [localClose, localState]);

    const submitProjectDelete = useCallback(() => {
        deleteUserProject({id: localState.id, userId: localState.userId}).then((response) => {
            localClose(response);
        });
    }, [localClose, localState]);

    useEffect(() => {
        setLocalState({...project});
    }, [project]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        if(event.isPresent === true) {
            event.endDate = new Date();
        }
        setLocalState({...localState, ...event});
    }

    // form groups are a little tighter here to make space for all of the items for entry
    return (
        <Modal
            open={open}
            onClose={localClose}
            size="lg"
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Edit Project</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack direction='column' alignItems='flex-start'>
                    <p>Responsibilities should be written as a list: one line per item in the textarea.</p>
                    <p>Do not add bullets. Bullets will be added as part of resume preview/generation.</p>
                </Stack>
            </Modal.Body>
            <Form
                layout="vertical"
                model={projectModel}
                onChange={handleFormChange}
                onSubmit={submitProjectEdit}
                formDefaultValue={project}
                fluid
            >
                <Form.Group>
                    <Form.ControlLabel>Experience</Form.ControlLabel>
                    <Form.Control name="expId"
                                  accepter={SelectPicker}
                                  data={userExperience}/>
                    <Form.ControlLabel>Project Name</Form.ControlLabel>
                    <Form.Control
                        name="projectName"
                        placeholder={projectNamePlaceholder}
                    />
                    <Form.ControlLabel>Start Date</Form.ControlLabel>
                    <Form.Control name="startDate" accepter={startDateInstance} />
                    <Form.ControlLabel>EndDate</Form.ControlLabel>
                    <Form.Control
                        name="endDate"
                        accepter={endDateInstance}
                        disabled={localState.isPresent}
                        value={localState.endDate}
                    />
                    <Form.ControlLabel>Present</Form.ControlLabel>
                    <Form.Control
                        name="isPresent"
                        accepter={Checkbox}
                        checked={localState.isPresent}
                        value={!localState.isPresent}
                    />
                    <Form.ControlLabel>Project Description</Form.ControlLabel>
                    <Form.Control
                        rows={2}
                        name="description"
                        accepter={descriptionTextArea}
                        placeholder={descriptionPlaceholder}
                    />
                    <Form.ControlLabel>Project Technologies</Form.ControlLabel>
                    <Form.Control
                        rows={2}
                        name="technologies"
                        accepter={technologiesTextArea}
                        placeholder={technologiesPlaceholder}
                    />
                    <Form.ControlLabel>Responsibilities</Form.ControlLabel>
                    <Form.Control
                        rows={10}
                        name="responsibilities"
                        accepter={responsibilitiesTextArea}
                        placeholder={responsibilitiesPlaceholder}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={localClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitProjectDelete} appearance="primary" color="red">
                            Delete Project
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default EditProjectModal;